import TiptapColor from "@tiptap/extension-color";
import { normalizeTextColor } from "@defectwise/pdf-report-core";

/**
 * The base extension's parseHTML reads element.style.color verbatim into the mark's `color`
 * attribute — pdfmake only accepts hex, so anything else silently failed to render in the PDF.
 * This isn't an occasional edge case: the browser's CSSOM canonicalizes `style.color` to
 * `rgb(...)` on *read* regardless of how it was set (confirmed — even a hex value round-trips
 * through parseHTML as "rgb(...)"), so essentially every paste was affected.
 *
 * custom-section-builder's getTextSpans/getMention in pdf-report-core already normalize at
 * PDF-render time (the actual source of truth, applies to every document regardless of what
 * produced it), but that left colour entering the editor's own document un-normalized — most
 * concretely, a pasted colour could never show up in the recent-colours swatches, since
 * addRecentColor only accepts hex. Normalizing at the point colour is parsed from HTML closes
 * that gap: this runs for a native Ctrl+C/paste inside the app (ProseMirror reconstructs by
 * parsing its own clipboard HTML back through this same rule), a genuinely external paste (Word,
 * a web page), and the app's own "Copy to clipboard" node action's native fallback — parseHTML
 * is the one place all three converge.
 */
export const Color = TiptapColor.extend({
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (element: HTMLElement) => {
              const raw = element.style.color?.replace(/['"]+/g, "");
              return raw ? normalizeTextColor(raw) : raw;
            },
            renderHTML: (attributes: { color?: string }) => {
              if (!attributes.color) {
                return {};
              }

              return {
                style: `color: ${attributes.color}`,
              };
            },
          },
        },
      },
    ];
  },
});

export default Color;
